import { type GTM } from '@vakantiesnl/types';
import { type NextWebVitalsMetric } from 'next/app';

import { basicGTMV2Event } from './basicGTMV2Event';

export const webVitalsEvent = ({ id, name, value }: NextWebVitalsMetric): GTM.GTMEventV2 =>
	basicGTMV2Event({
		type: 'web_vitals',
		organism: null,
		molecule: null,
		atom: null,
		action: name,
		page_type: '',
		sub_page: null,
		label: `web_vitals | ${name}`,
		value: {
			id,
			value: Math.round(name === 'CLS' ? value * 1000 : value),
		},
		_clear: false,
	});
